import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class CorrelationIdService {
  private correlationId?: string;

  get(): string | undefined {
    return this.correlationId;
  }

  set(value: string | undefined | null): void {
    if (value) {
      this.correlationId = value;
    }
  }
}
